import { useMutation, useQuery } from '@tanstack/react-query'

import {
  fetchFields,
  generateShareLinkToAddCustomer,
  generateShareLinkforVerifyingOtpToAddCustomer,
  getCustomerDetails,
  sendOtpToAddCustomer,
  submitEmploymentDetails,
  submitPanWithDetails,
  verifyOtpToAddCustomer,
} from './functions'

export function useGenerateShareLinkToAddCustomer() {
  return useMutation(generateShareLinkToAddCustomer)
}

export function useSendOtpToAddCustomer() {
  return useMutation(sendOtpToAddCustomer)
}

export function useVerifyOtpToAddCustomer() {
  return useMutation(verifyOtpToAddCustomer)
}

export function useGenerateShareLinkforVerifyingOtpToAddCustomer() {
  return useMutation(generateShareLinkforVerifyingOtpToAddCustomer)
}

export function useGetCustomerDetails(customerId) {
  return useQuery(
    ['getCustomerDetails', customerId],
    () => getCustomerDetails(customerId),
    { enabled: customerId ? true : false }
  )
}

export function useSubmitPanWithDetails() {
  return useMutation(submitPanWithDetails)
}

function useFetchFields() {
  return useQuery(['fetchFieldDetails'], fetchFields)
}

export function useFetchFieldsByCriteria(criteria: string) {
  const { data } = useFetchFields()
  return useQuery({
    queryKey: ['fetchCriteriaDetails', criteria],
    queryFn: () => {
      return data.find(
        (d: { criteriaName: string }) => d.criteriaName === criteria
      )
    },
    enabled: !!data,
  })
}

export function useSubmitEmploymentDetails() {
  return useMutation(submitEmploymentDetails)
}
